module.exports = __webpack_public_path__ + "static/media/us.ee147ede.jpg";